import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import Accueil from '../components/formSections/Accueil';
import InformationsDemandeur from '../components/formSections/InformationsDemandeur';
import InformationsLocal from '../components/formSections/InformationsLocal';
import InformationsProjet from '../components/formSections/InformationsProjet';
import Validation from '../components/formSections/Validation';
import FormulairePdf from '../components/formulairePdf/FormulairePdf';
import env from '../env/env.json';
import { fetchXretry } from '../services/fetchXretry';
import TransmissionCU from './TransmissionCU';

const FormulaireCU = ({ x_id_submit }) => {
  const [page, setPage] = useState(0);
  const [formData, setFormData] = useState({
    ProActivite: 'Location meublée courte durée (location touristique)',
    LocMandantStatut: 'Propriétaire',
  });
  const [signature, setSignature] = useState(null);
  const [tooltip, setTooltip] = useState(false);
  const [validResponse, setValidResponse] = useState(false);
  const [url3DOuest, setUrl3DOuest] = useState(null);
  const [loading, setLoading] = useState(false);

  //recherche de token dans les paramètres de l'url
  const paramsUrl = new URLSearchParams(document.location.search);
  const token = paramsUrl?.get('token');
  const ref_local = paramsUrl?.get('ref_local');
  const id_bien = paramsUrl?.get('id_bien');

  // ** const du fichier env.json */
  const environnement = env.environnement;
  const urlAPI = env[environnement];
  const ville = env.ville;

  let files = {};
  let filesTest = false;

  //liste villes avec leurs url de page de connexion 3D Ouest
  const listeUrls3DOuest = [
    {
      ville: 'Andernos-les-Bains',
      url: 'https://taxe.3douest.com/andernoslesbains.php',
      charte:
        'https://admin-touriz.fr/client/CLO00008/include/lire.php?lien=CE_andernos2.pdf',
    },
    {
      ville: 'Arcachon',
      url: 'https://taxe.3douest.com/arcachon.php',
      charte:
        'https://admin-touriz.fr/client/CLO00008/include/lire.php?lien=CE_arcachon.pdf',
    },
    {
      ville: 'Arès',
      url: 'https://taxe.3douest.com/ares.php',
      charte:
        'https://admin-touriz.fr/client/CLO00008/include/lire.php?lien=CE_Ares.pdf',
    },
    {
      ville: 'Audenge',
      url: 'https://taxe.3douest.com/coeurdubassin.php',
      charte:
        'https://admin-touriz.fr/client/CLO00008/include/lire.php?lien=CE_audenge.pdf',
    },
    {
      ville: 'Biganos',
      url: 'https://taxe.3douest.com/coeurdubassin.php',
      charte:
        'https://admin-touriz.fr/client/CLO00008/include/lire.php?lien=CE_biganos.pdf',
    },
    {
      ville: 'Gujan-Mestras',
      url: 'https://taxe.3douest.com/gujanmestras.php',
      charte:
        'https://admin-touriz.fr/client/CLO00008/include/lire.php?lien=CE_gujan.pdf',
    },
    {
      ville: 'Lanton',
      url: 'https://taxe.3douest.com/coeurdubassin.php',
      charte:
        'https://admin-touriz.fr/client/CLO00008/include/lire.php?lien=CE_lanton.pdf',
    },
    {
      ville: 'Lège-Cap Ferret',
      url: 'https://taxe.3douest.com/legecapferret.php',
      charte:
        'https://admin-touriz.fr/client/CLO00008/include/lire.php?lien=CE_lcf.pdf',
    },
    {
      ville: 'La Teste de Buch',
      url: 'https://taxe.3douest.com/latestedebuch.php',
      charte:
        'https://admin-touriz.fr/client/CLO00008/include/lire.php?lien=CE_latest2.pdf',
    },
    {
      ville: 'Le Teich',
      url: 'https://taxe.3douest.com/leteich.php',
      charte:
        'https://admin-touriz.fr/client/CLO00008/include/lire.php?lien=CE_leteich.pdf',
    },
    {
      ville: 'Marcheprime',
      url: 'https://taxe.3douest.com/coeurdubassin.php',
      charte:
        'https://admin-touriz.fr/client/CLO00008/include/lire.php?lien=CE_marcheprime.pdf',
    },
    {
      ville: 'Mios',
      url: 'https://taxe.3douest.com/coeurdubassin.php',
      charte:
        'https://admin-touriz.fr/client/CLO00008/include/lire.php?lien=CE_mios.pdf',
    },
  ];

  useEffect(() => {
    console.log(env.version);
    if (token && ref_local && id_bien) {
      localStorage.setItem(
        'url_params',
        JSON.stringify({ token, ref_local, id_bien })
      );
      document.location.assign(document.location?.href.split('?')[0]);
    }
  }, []);

  const getUrlConnexion3DOuest = (e) => {
    const currentObj = [...listeUrls3DOuest].find(
      (obj3DOuest) => obj3DOuest.ville === e.target.value
    );
    setUrl3DOuest(currentObj);
  };

  const fetchDataToken = async () => {
    const urlApi = urlAPI.path_data_3douest;

    const {
      token: tk,
      ref_local: reference_local,
      id_bien: idBien,
    } = JSON.parse(localStorage?.getItem('url_params'));
    const headers = { 'x-id-token': tk, 'Content-Type': 'application/json' };
    const body = { ref_local: reference_local, id_bien: idBien };
    /*
    token: 386c1ead95b581ce2744ada248f4fd4c

    pour le body => ref_local et id_bien:
    ref_local : 7987
    id_bien: 9166
    */

    try {
      const response = await fetch(urlApi, {
        method: 'POST',
        headers,
        body: JSON.stringify(body),
      });
      const data = await response.json();

      //objet "dosser" => adresse du local
      const {
        TIEDIV5,
        TIENOMF,
        TIEPRENOM,
        CTC_MAIL,
        CTC_TELEPHONE2,
        CTC_TELEPHONE,
        TIEMEMO,
        ADR_CODE: local_num_rue,
        ADR_ADR1: local_lib_voie,
        ADR_ADR2: local_complement,
        ADR_NUMAPPART,
        ADR_ESCALIER,
        ADR_BATIMENT,
        ADR_CP: local_cp,
        libville: local_ville,
        BIE_DLCREF,
        ADR_FAX: indice_rep_local,
        // ADR_ETAGE
      } = data?.[0].dossier;

      //objet "tier" => adresse du tier
      const {
        ADR_CODE,
        ADR_ADR1,
        ADR_ADR2,
        ADR_CP,
        ADR_VILLE,
        ADR_PAYS,
        ADR_FAX,
      } = data?.[0].tier;

      const preLoadFormData = {
        villeArcachonAutre: local_ville,
        MandantCivil:
          TIEDIV5 === 'Monsieur'
            ? 'M.'
            : TIEDIV5 === 'Madame'
            ? 'Mme.'
            : 'Mlle.',
        MandantPrenom: TIEPRENOM,
        MandantNom: TIENOMF,
        MandantNomNaissance: TIEMEMO,
        MandantEmail: CTC_MAIL,
        MandantEmailConfirme: CTC_MAIL,
        MandantAdrNum: ADR_CODE.split(' ')[0],
        MandantAdrRepetition: ADR_FAX || 'Aucun',
        MandantAdrRue: ADR_ADR1,
        MandantAdrComp: ADR_ADR2,
        MandantAdrCP: ADR_CP,
        MandantAdrVille: ADR_VILLE,
        MandantAdrPays: ADR_PAYS,
        MandantTel: CTC_TELEPHONE2,
        MandantTelFixe: CTC_TELEPHONE,
        ProNumEnregistrement: BIE_DLCREF,
        LocAdrNum: local_num_rue.split(' ')[0],
        LocAdrRepetition: indice_rep_local || 'Aucun',
        LocAdrRue: local_lib_voie,
        LocAdrComp: local_complement,
        LocAdrPorte: ADR_NUMAPPART,
        LocAdrEscalier: ADR_ESCALIER,
        LocAdrBat: ADR_BATIMENT,
        LocAdrCP: local_cp.toString(),
        ImmLocaliteAdr: local_ville,
        // LocRezChau: ADR_ETAGE > 0 ? "Non" : "Oui",
        // LocEtage: ADR_ETAGE > 0 ? ADR_ETAGE : "0"
      };

      const data3DOuest = [...listeUrls3DOuest].find(
        (data) => data.ville === local_ville
      );
      setUrl3DOuest(data3DOuest);

      setFormData((prev) => ({ ...prev, ...preLoadFormData }));
      localStorage.removeItem('url_params');
    } catch (error) {
      console.log('Aucune donnée utilisateur trouvée');
      localStorage.removeItem('url_params');
    }
  };

  // ** Permet la redirection vers la page d'accueil lorsque le formulaire est validé */
  const redirect = () => {
    nextPage();
  };

  const concatenateReferences = () => {
    const listReferences = JSON.parse(localStorage.getItem?.('reference'));
    const data = Object.entries(formData);
    const currentFormData = { ...formData };
    let finalRef = [];

    listReferences?.forEach((ref) => {
      const result = data.filter(([key]) => key === ref);
      for (let [keyRef, valueRef] of result) {
        finalRef.push(valueRef);
        // delete currentFormData[keyRef]
      }
    });
    setFormData({ ...currentFormData, ProAutoriPrec: finalRef.join('||') });
  };

  const redirectTimeout = () => {
    setTimeout(function () {
      redirect();
    }, 1000);
  };

  // ** Fonction permettant un scroll haut de page quand on clique sur les boutons suivant ou retour */
  const scrollToTop = () => {
    const element = document.getElementsByClassName('header');
    if (element) {
      window.scrollTo(0, 0);
    }
  };

  //** Fonction permettant de cibler les erreurs et de remonter à la première */
  const scrollToReview = () => {
    const elements = document.querySelectorAll('.is-invalid');
    elements.forEach((elem, i) => {
      if (i === 0) {
        elem.scrollIntoView({ block: 'center' });
      }
    });
  };

  //** Fonctions permettant de changer de page  */
  const preventPage = () => {
    setPage(page - 1);
    scrollToTop();
  };

  const nextPage = () => {
    let hasError = false;
    let errorRadio = false;
    const emailConfirm = document.querySelector('.confirmMandataireEmail');
    const confirmMandantEmail_P = document.querySelector(
      '.confirmMandantEmail_P'
    );
    // const confirmMandantEmail_M = document.querySelector(
    //   ".confirmMandantEmail_M"
    // )
    const inputs = document.querySelectorAll('.page-' + page + '-required');
    inputs.forEach((input) => {
      //** Permet de vérifier la validité de tous les inputs */
      if (input.required && input.value === '') {
        console.log(input);
        hasError = true;
        input.classList.add('is-invalid');
      }
      //** Permet de vérifier si les radiobox sont check */
      if (input.classList.contains('radio-group')) {
        const groupHasChecked = Array.from(
          document.getElementsByName(input.name)
        ).some((radio) => radio.checked);
        if (!groupHasChecked) {
          errorRadio = true;
          input.classList.add('is-invalid');
        }
      }
      //** Permet de vérifier la validité des selects */
      if (input.classList.contains('select-group')) {
        if (input.value === '') {
          hasError = true;
        }
        document.getElementsByName(input.name).forEach((select) => {
          if (select.value !== '') {
            hasError = false;
          }
        });
        if (hasError) {
          input.classList.add('is-invalid');
        }
      }
      //** Permet de vérifier la confirmation d'email */
      if (page === 1) {
        if (
          emailConfirm.value !== formData.MandataireEmail &&
          formData.MandataireOuiNon === 'Oui'
        ) {
          hasError = true;
          emailConfirm.classList.add('is-invalid');
        }
        if (confirmMandantEmail_P.value !== formData.MandantEmail) {
          hasError = true;
          confirmMandantEmail_P.classList.add('is-invalid');
        }
        // if (confirmMandantEmail_M.value !== formData.MandantEmail) {
        //   hasError = true
        //   confirmMandantEmail_M.classList.add("is-invalid")
        // }
      }
      scrollToReview();
    });
    //** Permet de vérifier les regex de certains input */
    document.querySelectorAll('.inputReg').forEach((input) => {
      const isValidInput = input.checkValidity();
      if (!isValidInput) {
        hasError = true;
        input.classList.add('is-invalid');
      }
    });

    // permet de vérifier si la reconduction est à "oui" et si le dossier du bénéficiaire à une correspondance avec la BDD
    //permet de gérer la liste des références si elle sont vides
    // if (page === 2) {
    //   //partie concernant les références
    //   const listeInputsReference = document.querySelectorAll("[name^='ProAutoriPrec-']")
    //
    //   listeInputsReference?.forEach(inputRef => {
    //     if (formData.ProPremierCU === "oui, je souhaite obtenir une nouvelle autorisation au profit d'un autre bien" && inputRef.value === "") {
    //       hasError = true
    //       inputRef.classList.add("is-invalid")
    //       return
    //     }
    //     inputRef.classList.remove("is-invalid")
    //
    //   })
    //   if (formData.ProPremierCU === "oui, je souhaite obtenir une nouvelle autorisation au profit d'un autre bien" && !hasError) {
    //     //permet de concatener les références par 2 pipes
    //     concatenateReferences()
    //
    //   }
    //
    //   //partie concernant le renouvellement
    //   const renouvellementInputs = document.querySelectorAll(".renouvellement-group")
    //
    //   if (formData.ProPremierCU !== "oui, je souhaite obtenir la reconduction de ma première autorisation pour 3 ans supplémentaires" ) {
    //     setFormData(prev => ({...prev, ProAutorisationPrec: "", nomTiers: "", prenomTiers: ""}))
    //   }
    //
    //   if (!validResponse && formData.ProPremierCU === "oui, je souhaite obtenir la reconduction de ma première autorisation pour 3 ans supplémentaires") {
    //     hasError = true
    //     toast.error("Votre renouvellement n'a pas été validé. Veuillez vérifier votre dossier")
    //
    //     renouvellementInputs?.forEach((input, idx) => {
    //       input.classList.add("is-invalid")
    //       if (idx === 0) {
    //         input.scrollIntoView({block: "center"})
    //       }
    //     })
    //   } else {
    //     renouvellementInputs?.forEach(input => input.classList.remove("is-invalid"))
    //   }
    // }

    if (!hasError && !errorRadio) {
      setPage(page + 1);
      scrollToTop();
    }
    // ** pour les tests, permet de passer les pages sans la gestion des erreurs */
    // setPage(page + 1);
    // scrollToTop();
  };

  //** Gestion des valeurs inputs et checkboxs */
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((values) => ({ ...values, [name]: value }));

    if (
      event.target.classList.contains('radio-group') ||
      event.target.classList.contains('select-group')
    ) {
      document
        .querySelectorAll(
          '.' + event.target.getAttribute('data-group') + '-group'
        )
        .forEach((element) => {
          formData[element.name] = '';
          element.classList.replace('is-invalid', 'is-valid');
        });
    }
  };

  const handleTrimValue = (event) => {
    const { name, value } = event.target;
    setFormData((values) => ({ ...values, [name]: value.trim() }));
  };

  //** Permet de checker la confirmation d'email */
  const handleChangeMandataireConfirm = (event) => {
    const { name, value } = event.target;
    setFormData((values) => ({ ...values, [name]: value }));
    if (event.target.value !== formData.MandataireEmail) {
      document
        .querySelector('.confirmMandataireEmail')
        .classList.add('is-invalid');
    }
  };

  const handleChangeMandantConfirm = (event) => {
    const confirmMandantEmail_P = document.querySelector(
      '.confirmMandantEmail_P'
    );
    // const confirmMandantEmail_M = document.querySelector(
    //   ".confirmMandantEmail_M"
    // )
    if (event.target.value !== formData.MandantEmail) {
      confirmMandantEmail_P.classList.add('is-invalid');
    }
    if (event.target.value !== formData.MandantEmail) {
      // confirmMandantEmail_M.classList.add("is-invalid")
    }
    const { name, value } = event.target;
    setFormData((values) => ({ ...values, [name]: value }));
  };

  //** Fonction permettant de supprimer la class "is-invalid" lorsqu'un input required est rempli */
  const inputFocus = () => {
    const inputs = document.querySelectorAll('.page-' + page + '-required');
    const inputsPro = document.querySelectorAll('.error');

    inputs.forEach((element) => {
      if (element.value !== '' || element.checked === true) {
        element.classList.replace('is-invalid', 'is-valid');
      }
    });
    inputsPro.forEach((element) => {
      if (element.value !== '') {
        element.classList.replace('is-invalid', 'is-valid');
      }
    });
  };

  //** Fonctions permettant de gérer l'ajout et la suppression des pièces jointes */
  const handleChangeFiles = (event) => {
    let res = {};
    setLoading(true);
    res['x-id-submit'] = x_id_submit;
    res['TypeForm'] = formData.TypeForm;
    res['ImmLocaliteAdr'] =
      formData.villeArcachonAutre || formData.ImmLocaliteAdr;
    res['reinitJustif'] = 0;
    res['name'] = event.target.files[0].name;
    res['RGPD_OK'] = 1;
    let selectedFile = event.target.files[0];
    const maxSize = 8 * 1024 * 1024;

    if (selectedFile.size > maxSize) {
      if (document.getElementById('input-file-' + event.target.name)) {
        document.getElementById('input-file-' + event.target.name).innerHTML =
          '';
        document
          .getElementById('file-size-alert_' + event.target.name)
          .classList.replace('d-none', 'd-block');
      }
      event.target.value = null;
      setLoading(false);
    } else {
      if (document.getElementById('file-size-alert_' + event.target.name)) {
        document
          .getElementById('file-size-alert_' + event.target.name)
          .classList.add('d-none');
      }
      filesTest = true;
      getBase64(selectedFile).then((data) => {
        res[event.target.name] = [data];
        let myHeaders = {
          'Content-Type': 'application/json',
        };
        console.log(res);
        let myInit = {
          method: 'POST',
          headers: myHeaders,
          body: JSON.stringify(res),
          mode: 'cors',
          cache: 'default',
        };
        console.log(myInit);
        fetch(urlAPI.path_justifs, myInit)
          .then((response) => {
            let result = response.json();
            return result;
          })
          .then((result) => {
            console.log(result);
            if (result.code === 200) {
              formData.files[event.target.name].push(selectedFile.name);
              setFormData((values) => ({ ...values, files: formData.files }));
            }
            setLoading(false);
          })
          .catch((reason) => {
            console.log(reason);
            toast.error(
              "Une erreur est survenue lors de l'envoi du fichier. Veuillez réessayer ultérieurement ou contacter le support si le problème persiste."
            );
            setLoading(false);
          });
      });
    }
  };

  //** Fonction permettant de réinitialiser les pièces jointes d'un seul input */
  const handleResetInputFiles = (event) => {
    let res = {};
    res['x-id-submit'] = x_id_submit;
    res['TypeForm'] = formData.TypeForm;
    res['ImmLocaliteAdr'] =
      formData.villeArcachonAutre || formData.ImmLocaliteAdr;
    res['reinitJustif'] = 1;
    res['filesDirection'] = event.target.id;
    let myHeaders = {
      'Content-Type': 'application/json',
    };
    console.log(res);
    let myInit = {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify(res),
      mode: 'cors',
      cache: 'default',
    };
    fetch(urlAPI.path_justifs, myInit)
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        console.log(result);
      })
      .catch((reason) => {
        console.log(reason);
      });
    if (event && event.target) {
      const name = event.target.name;
      const updateFiles = { ...formData.files };
      updateFiles[name] = [];
      document.getElementById('input-file-' + event.target.name).value = '';
      setFormData({ ...formData, files: updateFiles });
    }
  };

  const handleResetFiles = () => {
    let res = {};
    res['x-id-submit'] = x_id_submit;
    res['TypeForm'] = formData.TypeForm;
    res['ImmLocaliteAdr'] =
      formData.villeArcachonAutre || formData.ImmLocaliteAdr;
    res['reinitJustif'] = 1;
    let myHeaders = {
      'Content-Type': 'application/json',
    };
    console.log(res);
    let myInit = {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify(res),
      mode: 'cors',
      cache: 'default',
    };
    fetch(urlAPI.path_justifs, myInit)
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        console.log(result);
      })
      .catch((reason) => {
        console.log(reason);
      });
    document.querySelectorAll('.input-file').forEach((inputFile) => {
      inputFile.innerHTML = '';
    });
    document.querySelectorAll('.files-upload').forEach((inputEl) => {
      inputEl.value = '';
    });
    document.querySelectorAll('.file-size').forEach((fileSize) => {
      fileSize.classList.add('d-none');
    });
    document.querySelectorAll('.files-upload').forEach((el) => {
      files[el.name] = [];
    });
    setFormData({ ...formData, files });
  };

  function getBase64(file) {
    return new Promise((resolve, reject) => {
      if (typeof file === 'object') {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      } else {
        resolve('none');
      }
    });
  }

  //** Fonctions qui permette de gérer la signature */
  const sigRef = useRef();

  const handleSignatureEnd = () => {
    setSignature(sigRef.current.toDataURL());
    formData.Signature = signature;
    setFormData({ ...formData });
  };

  const clearSignature = () => {
    sigRef.current.clear();
    setSignature((formData.Signature = ''));
    setFormData({ ...formData });
  };

  //** Soumission du formulaire */
  const handleSubmit = (e) => {
    const sign = document.querySelector('.signatureCanva');
    let error = false;
    if (signature === null) {
      error = true;
      sign.classList.add('errorSignature');
      setTooltip(true);
    } else {
      sign.classList.remove('errorSignature');
      setTooltip(false);
    }
    if (!error) {
      e.target.setAttribute('disabled', 'disabled');
      document.querySelectorAll('.navigationBtn').forEach((btn) => {
        btn?.classList.add('d-none');
      });

      const toastFetch = toast.loading(
        "Votre formulaire est en cours d'envoi..."
      );
      let myHeaders = {
        'Content-Type': 'application/json',
      };
      getBase64().then((data) => {
        formData.PDF_CUCP = data;
        setFormData({ ...formData });
        let myInit = {
          method: 'POST',
          headers: myHeaders,
          body: JSON.stringify(formData),
          mode: 'cors',
          cache: 'default',
        };
        console.log(myInit);

        fetchXretry(urlAPI.path_form, myInit, 60000, 3)
          .then((response) => {
            console.log(response);
            try {
              return response.json();
            } catch (err) {
              return response;
            }
          })
          .then((result) => {
            if (result.error !== undefined && result.error === 'abort') {
              console.log('erreur de transmission');
              toast.update(toastFetch, {
                render:
                  'La soumission de vos informations a échoué à plusieurs reprises, merci de contacter: support@touriz.fr',
                type: 'error',
                isLoading: false,
                closeButton: true,
              });
            } else if (result.error !== undefined) {
              toast.update(toastFetch, {
                render:
                  'La soumission de vos informations a échoué, merci de contacter: support@touriz.fr ( ' +
                  result.error +
                  ' )',
                type: 'error',
                isLoading: false,
                closeButton: true,
              });
            } else {
              console.log('Formulaire envoyé');
              localStorage.clear();
              // Simuler la progression
              let progress = 0;
              setTimeout(() => {
                const interval = setInterval(() => {
                  progress += 1;
                  toast.update(toastFetch, {
                    render: `Progression : ${progress}%`,
                    progress: progress / 100,
                  });
                  if (progress >= 100) {
                    clearInterval(interval);
                    toast.update(toastFetch, {
                      render: 'Votre formulaire a bien été envoyé',
                    });
                    setTimeout(() => {
                      toast.dismiss(toastFetch);
                    }, 2000);
                    redirectTimeout();
                  }
                }, 40);
              }, 2000);
            }
          })
          .catch((reason) => {
            console.log(reason);
            toast.dismiss(toastFetch);
          })
          .catch((reason) => {
            console.log(reason);
            toast.dismiss(toastFetch);
          });
      });
    }
  };

  //** Gestion des changements de pages via la barre de navigation en haut du formulaire(breadcrumb) */
  const handlePageChange = (page) => {
    let error = false;
    document.querySelectorAll('#myForm').forEach((input) => {
      const isValidInput = input.checkValidity();
      if (!isValidInput) {
        error = true;
        toast.error(
          "Vous devez d'abord compléter cette page ou cliquer sur le bouton retour"
        );
      }
      if (!error) {
        setPage(page);
      }
    });
  };

  const renderPageTitles = () => {
    const pageTitles = [
      '1. Informations sur le demandeur',
      '2. Informations sur le projet',
      '3. Informations sur le local',
      'Validation',
    ];
    return pageTitles.map((pageTitle, index) => (
      <li
        key={index}
        className={
          page === index + 1 ? 'active' : page > index + 1 ? 'active' : null
        }
      >
        {page === 4 ? (
          <a href="#" data-bs-toggle="modal" data-bs-target="#modalResetFiles">
            {pageTitle}
          </a>
        ) : (
          <a href="#" onClick={() => handlePageChange(index + 1)}>
            {pageTitle}
          </a>
        )}
      </li>
    ));
  };

  const componentList = [
    <Accueil />,
    <InformationsDemandeur
      formData={formData}
      setFormData={setFormData}
      handleChange={handleChange}
      handleTrimValue={handleTrimValue}
      handleChangeMandataireConfirm={handleChangeMandataireConfirm}
      handleChangeMandantConfirm={handleChangeMandantConfirm}
      inputFocus={inputFocus}
      ville={ville}
      listeUrls3DOuest={listeUrls3DOuest}
      setUrl3DOuest={setUrl3DOuest}
      url3DOuest={url3DOuest}
      page={page}
      fetchDataToken={fetchDataToken}
    />,
    <InformationsProjet
      formData={formData}
      setFormData={setFormData}
      handleChange={handleChange}
      handleTrimValue={handleTrimValue}
      handleChangeMandataireConfirm={handleChangeMandataireConfirm}
      handleChangeMandantConfirm={handleChangeMandantConfirm}
      inputFocus={inputFocus}
      ville={ville}
      page={page}
      setValidResponse={setValidResponse}
      url3DOuest={url3DOuest}
      handleChangeFiles={handleChangeFiles}
      handleResetInputFiles={handleResetInputFiles}
    />,
    <InformationsLocal
      formData={formData}
      setFormData={setFormData}
      handleChange={handleChange}
      handleTrimValue={handleTrimValue}
      handleChangeMandataireConfirm={handleChangeMandataireConfirm}
      handleChangeMandantConfirm={handleChangeMandantConfirm}
      inputFocus={inputFocus}
      ville={ville}
      page={page}
    />,
    <Validation
      formData={formData}
      setFormData={setFormData}
      handleChange={handleChange}
      handleChangeMandataireConfirm={handleChangeMandataireConfirm}
      handleChangeMandantConfirm={handleChangeMandantConfirm}
      handleChangeFiles={handleChangeFiles}
      handleResetInputFiles={handleResetInputFiles}
      handleResetFiles={handleResetFiles}
      handleSignatureEnd={handleSignatureEnd}
      clearSignature={clearSignature}
      sigRef={sigRef}
      inputFocus={inputFocus}
      signature={signature}
      setSignature={setSignature}
      tooltip={tooltip}
      page={page}
      loading={loading}
    />,
    <FormulairePdf
      formData={formData}
      setFormData={setFormData}
      handleChange={handleChange}
      handleChangeMandataireConfirm={handleChangeMandataireConfirm}
      handleChangeMandantConfirm={handleChangeMandantConfirm}
      handleSignatureEnd={handleSignatureEnd}
      clearSignature={clearSignature}
      sigRef={sigRef}
      inputFocus={inputFocus}
      signature={signature}
      ville={ville}
      tooltip={tooltip}
      page={page}
      listeUrls3DOuest={listeUrls3DOuest}
    />,
    <TransmissionCU />,
  ];

  return (
    <form
      action=""
      id="myForm"
      className="form_container p-2 pb-5 p-md-5 pt-md-5 shadow needs-validation"
      noValidate
    >
      <input
        type="hidden"
        name="TypeForm"
        value={(formData.TypeForm = 'CUCP')}
        id="TypeForm"
        readOnly
      />
      <input
        type="hidden"
        name="x-id-submit"
        value={(formData['x-id-submit'] = x_id_submit)}
        id="x-id-submit"
        readOnly
      />
      <div
        className={
          page > 0 && page <= 4
            ? 'w-100 d-flex justify-content-end d-block d-md-none'
            : 'd-none'
        }
      >
        <p className="breadcrumb-small p-2">
          Etape {page} sur {componentList.length - 2}
        </p>
      </div>
      <div
        className={page > 0 && page <= 4 ? 'd-none d-lg-block pb-4' : 'd-none'}
      >
        <ul className="breadcrumb">{renderPageTitles()}</ul>
      </div>
      {componentList[page]}

      {/* Conditions d'affichage des boutons en fonction de la page où l'on se trouve */}
      {page === 0 ? (
        <div className="d-flex flex-column align-items-center justify-content-center">
          <div className="divider mt-5 mb-5"></div>
          <div className="d-flex flex-column justify-content-center align-items-center gap-4">
            {/* bloc html connexion plate-forme 3D Ouest */}
            <div
              className={
                JSON.parse(localStorage.getItem('url_params'))
                  ? 'd-none'
                  : 'container d-flex flex-column gap-3 border border-secondary p-5'
              }
            >
              {/*<h2 className="text-center">Plate-forme 3D Ouest</h2>*/}
              <div className="alert alert-info" role="alert">
                <span>
                  <i className="fas fa-info-circle"></i>&nbsp;
                  <strong>Pour information :</strong>&nbsp;Vous disposez de la
                  possibilité de remplir de manière automatique votre formulaire
                  de demande de changement d'usage. Pour ce faire, nous vous
                  invitons à vous connecter à votre espace personnel sur 3D
                  Ouest. Une fois connecté, cet espace vous offrira
                  l'opportunité de compléter automatiquement votre demande en
                  intégrant vos informations personnelles.
                </span>
              </div>
              <select
                className="form-select"
                onChange={(e) => getUrlConnexion3DOuest(e)}
              >
                <option value="">Sélectionnez une commune</option>
                {listeUrls3DOuest.map((obj3DOuest) => {
                  return (
                    <option value={obj3DOuest.ville} key={obj3DOuest.ville}>
                      {obj3DOuest.ville}
                    </option>
                  );
                })}
              </select>
              <button
                type="button"
                className="btn btn-warning btn-md"
                disabled={!url3DOuest?.url && true}
                onClick={() => document.location.assign(url3DOuest?.url)}
              >
                Accéder à mon espace 3D Ouest
              </button>
            </div>
            {/* fin connexion plate-forme 3D Ouest */}

            <div
              className={
                JSON.parse(localStorage.getItem('url_params'))
                  ? 'd-none'
                  : 'container orDivider my-2'
              }
            >
              <p style={{ fontSize: '1.2rem' }} className="text-center m-0">
                OU
              </p>
            </div>
            <button
              type="button"
              className="btn btn-warning btn-md"
              onClick={() => {
                if (JSON.parse(localStorage.getItem('url_params'))) {
                  fetchDataToken();
                }
                nextPage();
              }}
            >
              {JSON.parse(localStorage.getItem('url_params'))
                ? 'Continuez'
                : 'Déposer ma demande manuellement'}
            </button>
          </div>
        </div>
      ) : (
        page < 6 && (
          <div className="d-flex flex-column align-items-center justify-content-center">
            <div className="divider mt-5 mb-5"></div>
            <div
              className="modal fade"
              id="modalResetFiles"
              tabIndex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header border-0">
                    <h5 className="modal-title">
                      Le retour à la page précédente supprimera toutes les
                      pièces jointes
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <p>
                      Êtes-vous sur de vouloir revenir à la page précédente ?
                    </p>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-warning btn-md"
                      data-bs-dismiss="modal"
                    >
                      Annuler
                    </button>
                    <button
                      type="button"
                      className="btn btn-warning btn-md"
                      onClick={() => {
                        handleResetFiles();
                        preventPage();
                      }}
                      data-bs-dismiss="modal"
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="row d-flex justify-content-center">
              {page === 4 || page === 5 ? (
                <div className="col-6">
                  <div
                    className="btn btn-outline-warning btn-md navigationBtn"
                    data-bs-toggle="modal"
                    data-bs-target="#modalResetFiles"
                  >
                    Retour
                  </div>
                </div>
              ) : (
                <div className="col-6">
                  <div
                    className="btn btn-outline-warning btn-md"
                    onClick={preventPage}
                  >
                    Retour
                  </div>
                </div>
              )}
              {page === 5 ? (
                <div className="col-6">
                  <input
                    type="button"
                    className="btn btn-warning btn-md navigationBtn"
                    value="Valider"
                    onClick={(e) => {
                      handleSubmit(e);
                    }}
                  />
                </div>
              ) : (
                <div className="col-6">
                  <button
                    type="button"
                    className="btn btn-warning btn-md"
                    onClick={nextPage}
                  >
                    {page === 4 ? 'Vérifier' : 'Suivant'}
                  </button>
                </div>
              )}
            </div>
          </div>
        )
      )}
      {/* Permet de voir les données en temps réel */}
      {/* <pre className="pt-5 d-flex flex-column">
        <p>Visualisation de formData:</p>
        {JSON.stringify(formData, null, 2)}
      </pre> */}
    </form>
  );
};

export default FormulaireCU;
